export default palette => ({
  root: {
    borderRadius: '3px',
    overflow: 'hidden',
  },
  colorPrimary: {
    backgroundColor: palette.common.neutral,
  },
})
